import { Injectable } from '@angular/core';
import { SHA256, enc } from "crypto-js";

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  randomString(length: number): string {

    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    var result:string = '';

    for ( var i = 0; i < length; i++ ) {

        result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));

    }

    return result;
  }

  generateToken():string {
    const rand:string = this.randomString(32);
    const hashedPass:string = SHA256(rand).toString(enc.Hex);
    return hashedPass;
  }
}
